import { IonButtons, IonCol, IonContent, IonFooter, IonGrid
  , IonHeader, IonItem, IonLabel, IonMenuButton
  , IonPage, IonRow, IonTitle, IonToolbar 
  , IonModal, IonButton, IonText, IonSpinner, IonIcon, IonAlert, IonBackButton} from '@ionic/react';
  import React, { useEffect, useState, useRef } from 'react';
  import { logInOutline, logOutOutline, calendarOutline, personCircleOutline } from 'ionicons/icons';
//import { useParams } from 'react-router';
import './Bams.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import ServerService from '../../../services/Server';
import MapContainer, { MapContainerRef } from '../../../components/MapContainer';
import { useIonRouter } from '@ionic/react';
import { Environment } from "../../../data/Environment";
const Con: React.FC = () => {
 const router = useIonRouter();
 const [showCheckIn, setShowCheckIn] = useState<boolean>(false);
 const [showCheckOut, setShowCheckOut] = useState<boolean>(false);
 const [showConfirmAlert, setShowConfirmAlert] = useState(false);
 const [isLoadAddress, setIsLoadAddress] = useState<boolean>(false);
 const [showFailMsg, setShowFailMsg] = useState(false);
 const [showHistory, setShowHistory] = useState(false);

 const [checkInTime, setCheckInTime] = useState<string>("");
 const [checkOutTime, setCheckOutTime] = useState<string>("");

 const [sprintText, setSprintText] = useState<string>("กำลังระบุพิกัดที่แม่นยำ...");
 
 const [checkTitle, setCheckTitle] = useState<string>("");
 const [checkBtnText, setCheckBtnText] = useState<string>("");
 const [useCheckType, setUseCheckType] = useState<string>("");

 const [checkToDay, setCheckToDay] = useState(null);
 const [profile, setProfile] = useState(null);
 const [mapKey, setMapKey] = useState(null);

 const [allowCheckIn, setAllowCheckIn] = useState(false);
 const [allowCheckOut, setAllowCheckOut] = useState(false);


 const now = new Date();
 const dummy = now.getDate()+ '_' + now.getSeconds()+ '_' + now.getMinutes() + '_' + now.getHours();

const [myAddress, setMyAddress] = useState<string>("");
const [latitude, setLatitude] = useState<number>();
const [longitude, setLongitude] = useState<number>();
const [time, setTime] = useState<string>("");
const [jobId, setJobId] = useState<string>("");
const [urlProfile, setUrlProfile] = useState<any>(null);

const mapRef = useRef<MapContainerRef>(null);
//const [address, setAddress] = useState("");

const server = new ServerService();
const state = server.state;
const data = {username:state.username, password:state.password}


const fetchLogin = async () => {

  const data = {username:state.username, password:state.password}
  try {
    const response = await fetch("https://"+state.host+":"+state.port+Environment.API_PREFIX+"login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }else{
      const result = await response.json();
      console.log("Success:", result);
      state.ticket = result.data.ticket;
      state.base64ticket = result.data.ticket.toString('base64');
      fetchProfile();
      setUrlProfile(server.getFullUrl("bams/getImgProfile?alf_ticket="+server.state.ticket, null));
      fetchCheckToDay();
    }



  } catch (error) {
    console.error("Error:", error);
  }
};


useEffect(() => {
  fetchLogin();
  //fetchCheckToDay();
  //fetchProfile();
  //setUrlProfile(server.getFullUrl("bams/getImgProfile?alf_ticket="+server.state.ticket, null));
  /*server.login((success:boolean, msg:string) => {
    if (success) {
      server.log("systemConfig login success");
      fetchCheckToDay();
      fetchProfile();
      setUrlProfile(server.getFullUrl("bams/getImgProfile?alf_ticket="+server.state.ticket, null));
    } else {
      server.log("systemConfig login false");
    }
  });*/
}, []);

//var state = server.state;
//console.log(state);
//server.state = {...server.state}

const fetchCheckToDay = function() {
  const data = {
    alf_ticket : state.ticket
  }
  
  fetch(server.getFullUrl("bams/checkToDay", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(!result.success){
        return false;
      }else{
        setCheckInTime(result.checkintime);
        setCheckOutTime(result.checkouttime);
        if(!result.forgetCheckOut){
          if(!result.toDayCheckIn){
            setAllowCheckIn(true);
            setAllowCheckOut(false);
          }else if(result.toDayCheckIn && !result.toDayCheckOut){
            setAllowCheckIn(false);
            setAllowCheckOut(true);
          }else if(result.toDayCheckIn && result.toDayCheckOut){
            setAllowCheckIn(false);
            setAllowCheckOut(false);
          }
         
          setJobId(result.jobId);
        }else if(result.forgetCheckOut){
          setAllowCheckIn(false);
          setAllowCheckOut(true);
          setJobId(result.jobId);
        }
        

        setCheckToDay(result);
      }
    },
    (error) => {
      console.log('err 1');
    }
 ).catch(e => {
  console.log('err 2');
 })
).catch(e => {
  console.log('err 3');
}) 
}

const fetchProfile = function() {
  const data = { 
    alf_ticket : state.ticket
  }
  fetch(server.getFullUrl("bams/getProfile", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      if(result.status=='E'){
        return false;
      }else{
        setProfile(result.data);
        setMapKey(result.mapKey);
      }
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {
}) 
}

useEffect(() => {
  //fetchCheckToDay();
}, []);

useEffect(() => {
 
  //fetchProfile();
}, []);

  const sendCheckIn = function() {
    //2025-10-08 16:38:33;RC39+JX ตำบล มหาสวัสดิ์ อำเภอบางกรวย นนทบุรี ประเทศไทย|(13.804097544594082, 100.41999436738122)
    const data = {  
      alf_ticket : state.ticket,
      myAddress : myAddress,
      latitude : latitude ,
      longitude : longitude
    }
    fetch(server.getFullUrl("bams/checkIn", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        if(!result.success){
          return false;
        }else{
          setJobId(result.jobId);
          fetchCheckToDay();
        }
      },
      (error) => {
  
      }
   ).catch(e => {
  
   })
  ).catch(e => {
  }) 
  }


  const sendCheckOut = function() {
    //2025-10-08 16:38:33;RC39+JX ตำบล มหาสวัสดิ์ อำเภอบางกรวย นนทบุรี ประเทศไทย|(13.804097544594082, 100.41999436738122)
    const data = { 
      alf_ticket : state.ticket,
      jobId : jobId, 
      myAddress : myAddress,
      latitude : latitude ,
      longitude : longitude
    }
    fetch(server.getFullUrl("bams/checkOut", data),server.getRequest())
    .then(res => res.json()
    .then(
      (result) => {
        if(!result.success){
          return false;
        }else{
          fetchCheckToDay();
        }
      },
      (error) => {
  
      }
   ).catch(e => {
  
   })
  ).catch(e => {
  }) 
  }


useEffect(() => {
  const updateClock = () => {
    const now = new Date();
   
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    //setTime(`${hours}:${minutes}`);
    setTime(`${hours}:${minutes}:${seconds}`);
  };

  updateClock(); 
  const timerId = setInterval(updateClock, 1000); 

  return () => clearInterval(timerId);
}, []);

const handleCheckInClick = () => {
  setShowConfirmAlert(true); 
};

const handleFinalConfirm = () => {
  console.log("Checking mapRef.current:", mapRef.current);
  
  if (mapRef.current) {
    mapRef.current.triggerGetAddress();
    sendCheckInOut();
  } else {
    
    setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.triggerGetAddress();
        sendCheckInOut();
      } else {
        console.log("Ref is still null even after delay");
      }
    }, 100);
  }

};

const sendCheckInOut = () =>{
  if(latitude == 0.0){
  //if(true){ //test
    setShowFailMsg(true);
    return false;
  }else{
    const now = new Date();
    const timeStr = now.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' });
    if(useCheckType == 'in'){
      setCheckInTime(timeStr);
      sendCheckIn();
    }else if(useCheckType == 'out'){
      setCheckOutTime(timeStr);
      sendCheckOut();
    }

    setShowCheckIn(false);
  }
  
}
const handleModalDidPresent = () => {
  console.log("Modal presented, waiting for map...");
  setIsLoadAddress(true);
  
  setTimeout(() => {
    if (mapRef.current) {
      console.log("Triggering address fetch automatically...");
      setTimeout(() => {
        mapRef.current.triggerGetAddress();
      }, 2000);
    
     // setIsLoadAddress(false);  
     
    } else {
      console.log("MapRef is still null, trying again...");
     
      setTimeout(() => mapRef.current?.triggerGetAddress(), 2000);
      if(latitude == 0.0 || latitude == undefined){
        setSprintText("ไม่สามารถระบุพิกัดได้กรุณาตรวจสอบ GPS");
      }else{
       // setIsLoadAddress(false);  
      }
     
     
    }
  }, 3000); 
};
useEffect(() => {
  
  setIsLoadAddress(false);  
  
}, [latitude, longitude, myAddress]);
const handleAddressFromMap = (address: string) => {
  setMyAddress(address); 
  console.log("ไฟล์แม่ได้รับข้อมูลแล้ว:", address);
};

const handleLatitude = (lat: number) => {
  setLatitude(lat); 
  console.log("Latitude:", lat);
};
const handleLongitude = (lon: number) => {
  setLongitude(lon); 
  console.log("Longitude:", lon);
};
const handleOpenCheckInOut = (checkType : string) => {
  setCheckTitle("");
  setCheckBtnText("");
  setUseCheckType(checkType);
  console.log(checkType);
  if(checkType=='in'){
    setCheckTitle('ลงเวลาเข้า');
    setCheckBtnText('บันทึกเวลาเข้า');
  }else if(checkType=='out'){
    setCheckTitle('ลงเวลาออก');
    setCheckBtnText('บันทึกเวลาออก');
  }
 
  setShowCheckIn(true);

  //loadAddress();
};

const handleCloseMap = () => {
  console.log('handleCloseMap');
  setShowCheckIn(false);
  setLatitude(null);
  setLongitude(null);
  setMyAddress(null);
};


const handleOpenHistory = () => {
  //setShowHistory(true); 
  
};
/*useEffect(() => {
 
  if (showCheckIn && latitude && latitude !== 13.7563) {
  
    const timer = setTimeout(() => {
      if (mapRef.current) {
        mapRef.current.triggerGetAddress();
      }
    }, 1500); 
    return () => clearTimeout(timer);
  }
}, [latitude, showCheckIn]);*/

useEffect(() => {
  
}, [checkBtnText]);

 return (
 
  <IonPage>
  {/*
   <IonHeader>
  <IonToolbar className="blue-header">
    <IonTitle>Bams</IonTitle>
  </IonToolbar>
</IonHeader>
   */} 
   <IonHeader className="blue-header">
      <IonToolbar color="primary">
        <IonButtons slot="start">
          <IonBackButton defaultHref="/page/home/bams" />
        </IonButtons>
        <IonTitle style={{ fontWeight: 'bold' }}>ลงเวลา</IonTitle>
      </IonToolbar>
    </IonHeader>
   
  <IonContent className="ion-padding main-bg">
   
   
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '40px' }}>
      <div style={{
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        overflow: 'hidden',
        border: '3px solid var(--ion-color-primary)',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
      }}>
        <img src={urlProfile} alt="profile" />
      </div>
      {/*color="dark"*/}
      <IonText className="ion-text-color">
        <h2 className="profile-name" style={{ fontWeight: 'bold', marginTop: '15px', marginBottom: '5px' }}>{profile?.fullName}</h2>
        {/*<p style={{ margin: 0, opacity: 0.6, fontSize: '0.9rem' }}>รหัสพนักงาน: IT-67001</p>*/}
      </IonText>
    </div>

   
    <div style={{ textAlign: 'center', margin: '40px 0' }}>
      <IonText className="profile-name">
        <h1 style={{ fontSize: '4rem', fontWeight: 800, margin: 0 }}>{time}</h1>
      </IonText>
      <IonText className="profile-name">
        <p style={{ fontSize: '1.2rem', fontWeight: 500, marginTop: '5px' }}>
          {new Date().toLocaleDateString('th-TH', { 
            weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' 
          })}
        </p>
      </IonText>
    </div>

    
    <IonGrid>
      <IonRow>
        <IonCol size="6">
          {/*className="action-card in"*/} 
          <div  className={!allowCheckIn ? "action-card in disabledBtn" : "action-card in"} onClick={() => handleOpenCheckInOut('in')}>
          <IonIcon icon={logInOutline} style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#2dd36f' }} />
            <IonText className="profile-name"><b>ลงเวลาเข้า</b></IonText>
            <small>Check-In</small>
          </div>
        </IonCol>
        <IonCol size="6">
           {/*className="action-card out"*/} 
          <div className={!allowCheckOut ? "action-card out disabledBtn" : "action-card out"} onClick={() => handleOpenCheckInOut('out')}>
          <IonIcon icon={logOutOutline} style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#eb445a' }} />
            
            <IonText className="profile-name"><b>ลงเวลาออก</b></IonText>
            <small>Check-Out</small>
          </div>
        </IonCol>
      </IonRow>

      <IonGrid style={{ marginTop: '10px' }}>
  <IonRow>
    <IonCol size="12">
      <div style={{ 
        background: 'white', 
        borderRadius: '15px', 
        padding: '15px', 
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)' 
      }}>
        <IonLabel color="medium" style={{ fontSize: '0.85rem', fontWeight: 'bold', marginLeft: '5px' }}>
          สถานะวันนี้
        </IonLabel>
        
       
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '12px 5px',
          borderBottom: '1px solid #f0f0f0' 
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#2dd36f', marginRight: '10px' }}></div>
            <IonText className="profile-name">เข้างาน</IonText>
          </div>
          <IonText className="profile-name" style={{ fontWeight: 'bold' }}>
           
            {checkInTime || "--:--"} 
          </IonText>
        </div>

       
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          padding: '12px 5px' 
        }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#eb445a', marginRight: '10px' }}></div>
            <IonText className="profile-name">ออกงาน</IonText>
          </div>
          <IonText className="profile-name" style={{ fontWeight: 'bold' }}>
            {checkOutTime || "--:--"}
          </IonText>
        </div>
      </div>
    </IonCol>
  </IonRow>
</IonGrid>
      
     
      <IonRow>
        <IonCol size="12">
          {/*onClick={() => router.push('/page/home/bams/conForm/0/0', 'forward')}*/}
          <div className="history-card" onClick={() => router.push('/page/home/bams/bamsForm/0/0', 'forward')}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <IonIcon icon={calendarOutline} style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#3127F5' }} />
              <span style={{ fontSize: '1.5rem', marginRight: '15px' }}></span>
              <IonText className="profile-name"><b>ประวัติการลงเวลา</b></IonText>
            </div>
            <span>❯</span>
          </div>
        </IonCol>
      </IonRow>
    </IonGrid>
  </IonContent>

    {/*
     <IonContent>
    <IonText>
            <p>ที่อยู่ปัจจุบัน: {myAddress || "ยังไม่ได้กดดึงที่อยู่"}</p>
            <p>latitude: {latitude || "ยังไม่ได้กดดึงที่อยู่"}</p>
            <p>longitude: {longitude || "ยังไม่ได้กดดึงที่อยู่"}</p>
          </IonText>
    <IonButton onClick={handleOpenCheckIn}>CheckIn</IonButton>
    </IonContent>
    <IonFooter>
    </IonFooter>
    */} 
   

  <IonModal key={checkTitle} isOpen={showCheckIn} onDidPresent={handleModalDidPresent} className="custom-modal">
  <IonHeader className="ion-no-border">
    <IonToolbar color="primary">
      <IonTitle style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>
        {checkTitle}
      </IonTitle>
      <IonButtons slot="end">
        <IonButton onClick={handleCloseMap}>ปิด</IonButton>
      </IonButtons>
    </IonToolbar>
  </IonHeader>

  <IonContent className="ion-padding gray-bg">
   
    <div style={{ textAlign: 'center', marginBottom: '20px', marginTop: '10px' }}>
      <IonText className="profile-name">
        <h1 style={{ fontSize: '3rem', margin: '0', fontWeight: 'bold' }}>{time}</h1>
        <p style={{ fontSize: '1.1rem', opacity: '0.7', marginTop: '5px' }}>
          {new Date().toLocaleDateString('th-TH', { 
            day: 'numeric', month: 'long', year: 'numeric' 
          })}
        </p>
      </IonText>
    </div>

    
    <div style={{ 
      borderRadius: '20px', 
      overflow: 'hidden', 
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      border: '2px solid white',
      height: '300px'
    }}>
      <MapContainer 
        ref={mapRef} 
        apiKey={mapKey} 
        onAddressFetched={handleAddressFromMap} 
        onLatitudeFetched={handleLatitude}
        onLongitudeFetched={handleLongitude}
      />
    </div>

    
    <div style={{ 
      marginTop: '20px', 
      padding: '15px', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '15px',
      borderLeft: '5px solid var(--ion-color-primary)'
    }}>
      <IonLabel color="medium" style={{ fontSize: '0.9rem' }}>ตำแหน่งปัจจุบันของคุณ:</IonLabel>
      <div style={{ marginTop: '5px' }}>
    {(isLoadAddress) ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <IonSpinner name="crescent" color="primary" />
        <IonText className="profile-name">
          <small>{sprintText}</small>
        </IonText>
      </div>
    ) : (
      <IonText className="profile-name">
        <p style={{ margin: '0', fontWeight: 500, lineHeight: '1.4' }}>
          📍 {myAddress}
        </p>
      </IonText>
    )}
  </div>
    </div>
    <IonAlert
        isOpen={showFailMsg}
        onDidDismiss={() => setShowFailMsg(false)}
        message="ทำรายการไม่สำเร็จโปรดลองอีกครั้ง"
        buttons={['ตกลง']}
      ></IonAlert>
    <IonAlert
  isOpen={showConfirmAlert}
  onDidDismiss={() => setShowConfirmAlert(false)}
  header={'ยืนยัน'+checkBtnText}
  message={`คุณต้องการบันทึกเวลา ${checkTitle} ใช่หรือไม่?`}
  buttons={[
    {
      text: 'ยกเลิก',
      role: 'cancel',
      cssClass: 'secondary',
      handler: () => {
        console.log('User cancelled');
      }
    },
    {
      text: 'ยืนยัน',
      handler: () => {
        handleFinalConfirm(); 
      }
    }
  ]}
/>
   
    <div style={{ marginTop: '30px' }}>
      <IonButton 
        expand="block" 
        shape="round" 
        size="large"
        onClick={handleCheckInClick}
        disabled={isLoadAddress}
        style={{ height: '60px', fontWeight: 'bold', fontSize: '1.1rem' }}
      >
        <span style={{ marginRight: '10px' }}>📍</span> {checkBtnText}
      </IonButton>
    </div>
  </IonContent>
</IonModal>

  </IonPage>

);
};

export default Con;
